export default __webpack_public_path__ + "static/media/border-outer.6de0888f.svg";